import { SEO } from "@/components/SEO"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export function AdminSettingsPage() {
  return (
    <>
      <SEO
        title="Admin Settings"
        description="Internal admin settings console."
      />

      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Admin Settings</h1>
          <p className="text-muted-foreground mt-1">
            Manage roles, permissions, SSO, domains, and platform settings.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <Card className="lg:col-span-2">
            <CardHeader>
              <CardTitle>Access control</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="rounded-lg border bg-muted/20 p-4 text-sm text-muted-foreground">
                Placeholder UI for roles, permissions, audit logs, and security policies.
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Platform</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="rounded-lg border bg-muted/20 p-4 text-sm text-muted-foreground">
                Placeholder UI for branding, email templates, feature flags, etc.
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  )
}

